import React from 'react';
import { ReportWheelGameExportContainerStyled } from './styled';
import moment from 'moment';
import 'moment-timezone';
import { Tables, Buttons, Displays } from 'components';
import { renderRedemptionStatus } from 'utils/functions/RedemptionStatus';
import { scrollToTopPageFN } from 'utils/functions/scrollTopPage';
import * as XLSX from 'xlsx';

class ReportWheelGameExportContainer extends React.Component {
  state = { isLoading: true };

  componentDidMount() {
    scrollToTopPageFN();
    setTimeout(() => {
      this.setState({ isLoading: false });
    }, 500);
  }

  handleDownloadExcel = async () => {
    const { data } = this.props;
    var wb = XLSX.utils.book_new();
    var ws_name = 'SheetJS';
    if (data) {
      var ws_data = data.reduce((result, e, i) => {
        result.push([
          i + 1,
          moment(e.created_at).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm'),
          `${e.firstname_shipping || e?.consumer_detail?.firstname || ''} ${
            e.lastname_shipping || e?.consumer_detail?.lastname || ''
          }`.trim(),
          e.phone_number_shipping || e?.consumer_detail?.phone_number || '',
          e.reward_name,
          e.address_province || '',
          renderRedemptionStatus(e.reward_type, e.status),
        ]);
        return result;
      }, []);
      ws_data.splice(0, 0, [
        'No',
        'วันที่แลก',
        'ชื่อผู้แลก',
        'เบอร์โทรศัพท์',
        'ชื่อของรางวัล',
        'จังหวัด',
        'สถานะ',
      ]);
      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      ws['!cols'] = [
        { wch: 5 },
        { wch: 18 },
        { wch: 25 },
        { wch: 15 },
        { wch: 30 },
        { wch: 15 },
        { wch: 15 },
      ];
      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(
        wb,
        `Report การแลกของรางวัล (Wheel game) ${moment()
          .tz('Asia/Bangkok')
          .format('DD-MM-YYYY')}.xlsx`
      );
    }
  };

  render() {
    const { onCloseModal, data } = this.props;
    const { isLoading } = this.state;
    return (
      <ReportWheelGameExportContainerStyled>
        {isLoading ? (
          <div className="loading_show">
            <Displays.Loading />
          </div>
        ) : (
          <>
            <div className="btn_action">
              <div className="btn175">
                <Buttons.BtnNormal
                  theme_normal_btn
                  label="ย้อนกลับ"
                  onClick={onCloseModal}
                />
              </div>
              <div className="btn175">
                <Buttons.BtnNormal
                  theme_normal_btn
                  label="Export"
                  onClick={this.handleDownloadExcel}
                />
              </div>
            </div>
            <Tables.TableNormal
              theme_standard_table_normal
              useNo
              columns={columns}
              data={data}
            />
          </>
        )}
      </ReportWheelGameExportContainerStyled>
    );
  }
}

const columns = [
  {
    title: 'ลำดับ',
    field: 'no',
    headerStyle: { textAlign: 'center', width: '50px', flexShrink: 0 },
    style: { textAlign: 'center', width: '50px', flexShrink: 0 },
  },
  {
    title: 'วันที่แลก',
    field: 'created_at',
    headerStyle: { textAlign: 'center' },
    style: { textAlign: 'left' },
    render: ({ value }) =>
      `${moment(value).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm')}`,
  },
  {
    title: 'ชื่อผู้แลก',
    field: 'firstname_shipping',
    headerStyle: { textAlign: 'center' },
    style: { textAlign: 'left' },
    render: ({ origin }) =>
      `${origin.firstname_shipping || origin?.consumer_detail?.firstname || '-'} ${
        origin.lastname_shipping || origin?.consumer_detail?.lastname || ''
      }`,
  },
  {
    title: 'เบอร์โทรศัพท์',
    field: 'phone_number_shipping',
    headerStyle: { textAlign: 'center' },
    style: { textAlign: 'left' },
    render: ({ origin, value }) =>
      value || origin?.consumer_detail?.phone_number || '-',
  },
  {
    title: 'ชื่อของรางวัล',
    field: 'reward_name',
    headerStyle: { textAlign: 'center' },
    style: { textAlign: 'left' },
  },
  {
    title: 'จังหวัด',
    field: 'address_province',
    headerStyle: { textAlign: 'center' },
    style: { textAlign: 'left' },
    render: ({ value }) => value || '-',
  },
  {
    title: 'สถานะ',
    field: 'status',
    headerStyle: { textAlign: 'center' },
    style: { textAlign: 'center' },
    render: ({ origin }) => renderRedemptionStatus(origin.reward_type, origin.status),
  },
];

export default ReportWheelGameExportContainer;
